export const zh = {
    // Header
    'header.title': '🎭 揭露基恩',
    'header.subtitle': 'Tom Kean Jr. (NJ-7) — 不关心你的医疗保健。',

    // Hero Section
    'hero.quote': 'Tom Kean Jr.: "我告诉选民我是独立派。然后我投票支持MAGA。"',
    'hero.subtext': '4名共和党人叛变救救ACA补贴。12月17日，4名GOP立法者展现了勇气，加入民主党强制投票。Tom Kean Jr. (NJ-7)？他保持沉默。12月，Kean在由17位共和党参议员参与的GOP联名呼吁中署名支持延长ACA补贴——但他仍与众议院共和党人一起投票阻止延长。2200万美国人从1月1日起将面临114%的保费增长。',

    // Breaking News
    'news.hospitalRevenue': '新泽西医院收入自疫情以来大涨，CEO薪酬也同步飃升',

    // Kean Did Not Support Section
    'kean.betrayal.title': 'TOM KEAN JR. 拒绝为你站出来',
    'kean.betrayal.text': '12月17日，4名来自摇摆地区的共和党人（Brian Fitzpatrick、Rob Bresnahan Jr.、Ryan Mackenzie来自宾州，Mike Lawler来自纽约）背叛党派，加入民主党强制就延长ACA补贴进行投票。Rep. Tom Kean Jr. (NJ-7) 不在其中。他选择了党派忠诚而不是你的医疗保健。',
    'kean.betrayal.comparison': '这4名共和党人展现了勇气。Kean展现了懦弱。',
    'kean.betrayal.cta': '质问Kean：你为什么不为我们站出来？',

    // Healthcare Context Section
    'context.title': '共和党人不关心你的医疗保健："医疗成本海啸"已然来临',
    'context.intro': '共和党国会议员Tom Kean Jr.（NJ-7）没有为支持您的医疗保健做任何事情。准备好为一切支付更多费用：保费、医生诊费、处方药。您将如何负担这些？12月16日，众议院共和党人否决了民主党延长ACA补贴的努力。民主党一直在为您的医疗保健而战——通过ACA、降低关键药品价格等等。但Tom Kean Jr.与他的党派一起投票，让这些保护过期。',
    'context.truth.title': '真相：对新泽西家庭的真实影响',
    'context.truth.text': '新泽西州Mahwah居民Tina Jump得知她的ACA保费将从<strong>每月400美元飙升到每月1100美元以上</strong>——几乎增加了三倍。"我不知道我该怎么支付，"她告诉CBS新闻。',
    'context.impact': '<strong>2200万美国人</strong>有资格获得税收抵免，现在面临艰难的财务决定。自付保费成本将<strong>平均增加114%</strong>，年度成本增加1016美元。一个年收入75,000美元的四口之家可能会看到保费额外增加<strong>3,368美元</strong>。',
    'context.tsunami': '"我们将在1月1日看到医疗成本海啸般增加，"Community Catalyst的Michelle Sternthal说。据国会预算办公室称，约<strong>400万人可能会放弃健康保险</strong>，因为保费更高。',
    'context.exposed.title': '揭露：谁最脆弱？',
    'context.exposed.text': '小企业主和自雇人士特别处于风险之中。大约一半参加ACA的成年人是小企业主、受雇于员工少于25人的公司或自雇人士。',
    'context.accountability': 'Rep. Tom Kean Jr. (NJ-7) 与他的政党一起投票让这些补贴到期。国会民主党人正在发起解除请愿，强制就延长ACA保费税收抵免进行投票。赢得众议院的道路直接穿过新泽西。是时候让他负责了。',
    'context.cta': '立即行动',

    // ACA Section
    'aca.title': '共和党人正在夺走您的医疗保健 — ACA补贴已于12月31日到期',
    'aca.text': '众议院共和党人于12月16日阻止了ACA补贴的延期。从1月1日起，保费将平均飙升114%。一些家庭，如年收入72,000美元的Mahwah居民，将看到成本几乎翻三倍——从每月400美元到每月1100美元以上。Rep. Tom Kean Jr. (NJ-7)与他的政党一起投票阻止了这条生命线。',
    'aca.chart.title': '平均保费增长',
    'aca.chart.2025': '2025年',
    'aca.chart.2026': '2026年',
    'aca.chart.withSubsidies': '有补贴',
    'aca.chart.increase': '+114%平均',

    // No Kean Day Section
    'nokean.title': '无基恩日！',
    'nokean.date': '每个月的7日。',
    'nokean.message': '向他发送信息！',
    'nokean.standup': '为医疗保健站起来',
    'nokean.handle': '@CongressmanKean',
    'nokean.caption': '"我避开市政厅，因为镜子让我不舒服。"',

    // Voting Record Section
    'voting.title': '📜 收据很清楚',
    'voting.record.title': 'Tom Kean Jr.的投票记录',
    'voting.bill.name': 'H.R.1 - 一个伟大美丽法案',
    'voting.bill.congress': '第119届国会（2025-2026）| 公法119-21',
    'voting.bill.rollcall': '点名投票 #145 | 2025年5月22日',
    'voting.bill.cut1': '• 削减ACA补贴 - 导致174%的保费增长',
    'voting.bill.cut2': '• 减少Medicaid资金，影响新泽西家庭',
    'voting.breakdown.title': '投票明细',
    'voting.breakdown.yeas': '✓ 赞成：215（全部共和党）',
    'voting.breakdown.nays': '✗ 反对：214（全部民主党）',
    'voting.breakdown.present': '出席：1',
    'voting.breakdown.notvoting': '未投票：2',
    'voting.breakdown.passed': '通过',
    'voting.kean.name': 'TOM KEAN JR.',
    'voting.kean.title': '代表，NJ-7',
    'voting.kean.vote': '赞成',
    'voting.kean.result': '投票削减医疗保健',
    'voting.source': '来源：美国众议院书记官办公室 | clerk.house.gov/Votes/2025145',
    'voting.cta.vote': '查看基恩的投票',
    'voting.cta.bill': '阅读法案（H.R.1）',

    // Medicaid Section
    'medicaid.title': 'Tom Kean Jr.: "我称之为\'财政责任\'"',
    'medicaid.text': 'Rep. Tom Kean Jr. (NJ-7)支持削减Medicaid，威胁老年人、儿童和残疑人。这些削减减少了对医生、医院和长期护理的访问。每一票都说出真相——即使他不说。',
    'medicaid.visual': 'Medicaid = 生命线',
    'medicaid.hashtags': '#揭露基恩 #追踪资金',
    'medicaid.hashtags.text': '#揭露基恩 #追踪资金 #共和党不关心你的医疗保健',

    // Medicare Section
    'medicare.title': 'Tom Kean Jr.: "我没有失去我的声音。我把它给了特朗普。"',
    'medicare.subtext': '共和党提案包括数千亿美元的Medicare削减。Rep. Tom Kean Jr. (NJ-7) 与这些努力保持一致，威胁老年人的医疗保健。',
    'medicare.bullet1': 'GOP预算草案提议削减4790亿美元的Medicare（支付结构、资格变更）。',
    'medicare.bullet2': '"一个伟大美丽法案"包含限制Medicare访问的条款。',
    'medicare.bullet3': 'NJ-7的老年人依赖Medicare进行医院就诊、处方和长期护理。',
    'medicare.cta': '保护Medicare——立即行动',
    'medicare.visual': 'Medicare = 生命线。\n扫描二维码采取行动。',

    // Accountability Section
    'accountability.title': '面具已摘下。让Tom Kean Jr.负责。',
    'accountability.text': '"有时沉默不是金。它是伪装成谨慎的懦弱。"Rep. Tom Kean Jr. (NJ-7)的记录很清楚：成本更高，护理更少，困难更多。NJ-7值得更好的。',
    'accountability.cta': '加入 #寻找基恩星期五',

    // News Sources Section
    'news.title': '📰 更多收据',
    'news.updated': '更新于2026年6月23日',
    'news.cbs': 'CBS新闻：数百万人面临保费飙升',
    'news.wsj': '纽约时报：特朗普收紧医疗补助工作要求规则',
    'news.bloomberg': '彭博：医疗成本比油价或食品更令人担忧',
    'news.nytimes': '纽约时报：4名共和党人叛变强制投票',
    'news.nytimes2': '纽约时报：众议院阻止奥巴马医改补贴延期',
    'news.nytimes3': '纽约时报：共和党人推动民主党提案越过终点线',
    'news.cnn': 'CNN：美国人医疗支出创历史新高',
    'news.nytimes4': '纽约时报：奥巴马医保健康保险遭削减',
    'news.localHospitals': 'North Jersey：12家新泽西医院因医疗补助削减面临关闭风险',
    'news.localCoverage': 'North Jersey：35万新泽西居民可能因特朗普预算案失去医保',
    'news.npr1': 'NPR：特朗普和共和党人放任价格飙升后，500万人退出了ACA医保',

    // Footer
    'footer.tagline': '真相伤人。谎言代价更高。共和党人不关心你的医疗保健。',
    'footer.hashtags': '#揭露基恩 #没有国王 #共和党不关心你的医疗保健',
    'footer.disclaimer': '真相伤人。谎言代价更高。共和党人不关心你的医疗保健。#揭露基恩 #没有国王 #RepublicansDontCareAboutYourHealthcare',
    'footer.terms': '使用条款',
    'footer.privacy': '隐私政策',
    'footer.contact': '联系我们',
};

export default zh;
